import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { Breadcrumb } from 'antd';
import { HomeOutlined } from '@ant-design/icons';
import { BreadcrumbWrapper } from './styled';
import CombinedBreadcrumbDropdown from './CombinedBreadcrumbDropdown';
import { hasAiAlertSelector, selectedAiAlertSelector } from '@src/store/trends/aiAlerts/selectors';
import { isEmpty } from 'lodash';
import FlowNavTitle from './FlowNavTitle';

const FlowBreadcrumb = ({ flowId, flowConfigMeta, title, isSharedSaved }) => {
  const navigate = useNavigate();
  const hasAiAlert = useSelector(hasAiAlertSelector);
  const alert = useSelector(selectedAiAlertSelector);

  const handleOverviewClick = (e) => {
    e.preventDefault();
    navigate('/app/app-insights/dashboard/overview');
  };

  const handleAIAlertClick = (e) => {
    e.preventDefault();
    navigate('/app/app-insights/dashboard/ai-alerts');
  };

  const hasAlert = hasAiAlert && !isEmpty(alert);

  const overviewBreadcrumbItem = {
    title: (
      <a onClick={handleOverviewClick}>
        <HomeOutlined style={{ marginRight: 6, fontSize: '16px' }} /> Overview
      </a>
    ),
  };

  const aiAlertBreadcrumbItem = {
    title: (
      <a onClick={handleAIAlertClick}>
        <HomeOutlined style={{ marginRight: 6, fontSize: '16px' }} /> AI Alerts
      </a>
    ),
  };

  const flowNavTitleItem = {
    title: <FlowNavTitle flowId={flowId} flowConfigMeta={flowConfigMeta} />,
  };

  const combinedDropdownItem = {
    title: <CombinedBreadcrumbDropdown flowId={flowId} title={title} type="flow" />,
  };

  if (hasAlert) {
    return (
      <BreadcrumbWrapper>
        <Breadcrumb separator=">" items={[aiAlertBreadcrumbItem, flowNavTitleItem]} />
      </BreadcrumbWrapper>
    );
  }

  if (isSharedSaved) {
    return (
      <BreadcrumbWrapper>
        <Breadcrumb separator=">" items={[overviewBreadcrumbItem, flowNavTitleItem]} />
      </BreadcrumbWrapper>
    );
  }

  return (
    <BreadcrumbWrapper>
      <Breadcrumb separator=">" items={[overviewBreadcrumbItem, combinedDropdownItem]} />
    </BreadcrumbWrapper>
  );
};

export default FlowBreadcrumb;
